import styled from "styled-components";

import { InputWrapperBaseCss } from "../_input-base-wrapper";

export const TextArea = styled.textarea`
  ${InputWrapperBaseCss};
  width: 100%;
  display: flex;
  align-items: center;
  background: #fff;
  padding: 9px 14px 9px 10px;
  border: 1px solid #cacaca;
  box-sizing: border-box;
  border-radius: 5px;
  resize: vertical;
  height: 80px;
`;
